import React, {useState} from 'react';

import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import {withStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import LinearProgress from '@material-ui/core/LinearProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import {eartagDysstasiaImportAPI} from 'api/eartag-dysstasia-import.js';
import {ErrorUtil} from 'utils/error-util.js';
import {GlobalCss} from 'components/global-css.js';
import {ErrorMessage} from 'components/ErrorMessage.js';
import {DialogActions, DialogContent, DialogContentText} from '@material-ui/core';

const styles = {
  flexContainer: GlobalCss.flexContainer,
};

const EartagDysstasiaImportIndex = (props) => {
  const classes = props.classes;
  const env = process.env.REACT_APP_ENVIRONMENT || 'local';

  const isProd = env === '本番';
  const S3_BUCKET = isProd ? 'eartag-analyze-result-prod' : 'eartag-analyze-result-dev';
  const S3_DIRECTORY = 'lying-anomaly-recovery/';

  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [showDialog, setShowDialog] = useState(false);
  const [result, setResult] = useState(null);
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const executeImport = () => {
    setOpen(false);
    setIsLoading(true);
    setErrorMessage('');
    setResult(null);

    eartagDysstasiaImportAPI.execute().then((res) => {
      setIsLoading(false);
      setShowDialog(true);
      const data = res.data;

      setTimeout(() => {
        setShowDialog(false);
        setResult({
          loadCount: data.load_count,
          message: data.message,
          success: data.success,
        });
      }, 1000);
    }).catch((error) => {
      setIsLoading(false);
      setErrorMessage(ErrorUtil.generateMessage(error));
    });
  };

  return (
    <div style={{marginLeft: '20px'}}>
      <h2>[イヤタグ] 起立困難スコア連携</h2>
      <p style={{marginLeft: 40, marginBottom: 20}}>
        S3上の起立困難スコアCSVファイルを読み込み、データベースへ反映します。<br />
        一度の実行で最大30ファイルを反映します。<br />
        対象： s3://{S3_BUCKET}/{S3_DIRECTORY}
      </p>

      <Dialog
        open={open}
        onClose={handleClose}
        TransitionComponent={Slide}
        aria-labelledby="confirm-dialog"
      >
        <DialogTitle id="confirm-dialog">実行しますか？</DialogTitle>
        <DialogContent>
          <DialogContentText>
            s3://{S3_BUCKET}/{S3_DIRECTORY} 配下の起立困難スコアが反映されます。<br />
            この操作は取り消せません。<br />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            color="secondary"
            autoFocus onClick={handleClose}
          >
            キャンセル
          </Button>
          <Button
            onClick={executeImport}
            color="primary">
            実行
          </Button>
        </DialogActions>
      </Dialog>

      <Button
        variant="contained"
        color="primary"
        onClick={() => setOpen(true)}
        disabled={isLoading}
        style={{marginLeft: 40}}
      >
        実行
      </Button>

      <div style={{marginLeft: '40px'}}>
        <ErrorMessage errorMessage={errorMessage} />
      </div>

      <div style={{width: 300, marginBottom: 10, marginLeft: 200}}>
        {isLoading ? <LinearProgress /> : null}
      </div>

      <Dialog
        open={showDialog}
        onClose={() => setShowDialog(false)}
        TransitionComponent={Slide}
        aria-labelledby="notification-dialog"
      >
        <DialogTitle id="notification-dialog">完了しました</DialogTitle>
      </Dialog>

      {result && (
        <div style={{marginTop: 30, marginLeft: 40}}>
          <div style={{fontSize: 20}}>
            実行結果
          </div>

          <ul className={classes.flexContainer} style={{marginBottom: 10}}>
            <li style={{width: 120, marginTop: 10}}>
              <InputLabel style={{fontWeight: 'bold', marginTop: 5}}>実行結果:</InputLabel>
            </li>
            <li style={{paddingTop: 5}}>
              <TextField
                type="text"
                value={result.success ? '成功' : '失敗'}
                disabled={true}
                margin="none"
                style={{width: 80}}
              />
            </li>
          </ul>

          <ul className={classes.flexContainer} style={{marginBottom: 10}}>
            <li style={{width: 120, marginTop: 10}}>
              <InputLabel style={{fontWeight: 'bold', marginTop: 5}}>レコード数:</InputLabel>
            </li>
            <li style={{paddingTop: 5}}>
              <TextField
                type="text"
                value={`${result.loadCount}件`}
                disabled={true}
                margin="none"
                style={{width: 80}}
              />
            </li>
          </ul>

          <ul className={classes.flexContainer} style={{marginBottom: 10}}>
            <li style={{width: 120, marginTop: 10}}>
              <InputLabel style={{fontWeight: 'bold', marginTop: 5}}>メッセージ:</InputLabel>
            </li>
            <li style={{paddingTop: 5}}>
              <TextField
                type="text"
                value={result.message || ''}
                disabled={true}
                margin="none"
                style={{width: 300}}
              />
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

EartagDysstasiaImportIndex.propTypes = {
  classes: PropTypes.object.isRequired
};

const forExport = withRouter(withStyles(styles)(EartagDysstasiaImportIndex));
export {forExport as EartagDysstasiaImportIndex};
